import { useEffect } from 'react';

import { extractFromSlug } from 'helpers/utils';

type UsePremiumLandingDataOptions = {
  sessionSlug: string | undefined;
  redirectToCourseLanding: boolean;
  fetchOverviewData: (slug: string) => Promise<void>;
  externalLoadingError: () => void;
};

/**
 * Fetches premium overview data when staying on Premium Landing (no redirect).
 */
export default function usePremiumLandingData({
  sessionSlug,
  redirectToCourseLanding,
  fetchOverviewData,
  externalLoadingError,
}: UsePremiumLandingDataOptions) {
  useEffect(() => {
    if (!sessionSlug || redirectToCourseLanding) return;

    const { version } = extractFromSlug(sessionSlug);

    if (version) {
      fetchOverviewData(sessionSlug).catch(() => {});
    } else {
      externalLoadingError();
    }
  }, [
    sessionSlug,
    redirectToCourseLanding,
    fetchOverviewData,
    externalLoadingError,
  ]);
}
